document.addEventListener("DOMContentLoaded", () => {
  const beforeContentHeaderImage = document.querySelector(
    "#before-content .views-field-field-header-image"
  ) ||
  document.querySelector(
    "#before-content .views-field-field-cover-image"
  ),
    mainHeaderImage =
      document.querySelector(
        ".page-node-type-about-us #main .field-header-image"
      ) ||
      document.querySelector(
        ".page-node-type-page #main .field-header-image"
      ) ||
      document.querySelector(
        ".page-node-type-language-page #main .field-header-image"
      ),
    mainHeaderImageWithoutType = document.querySelector(
      "#main .field-header-image"
    ),
    mainMobileHeaderImage = document.querySelector(
      "#main .field-mobile-header-image"
    ),
    mainHeaderSlideshow = document.querySelector(
      "#main .header-slideshow"
    ),
    pageNodePage = document.querySelector(
      ".page-node-type-page"
    ),
    pageNodeBikesPrices = document.querySelector(
      ".page-node-type-bikes-and-prices-for-locations"
    );

  if (beforeContentHeaderImage || mainHeaderImage) {
    let fadingHeaderImageExists = null;

    if (beforeContentHeaderImage) {
      fadingHeaderImageExists = document.querySelector(
        "#before-content .views-field-field-header-image .fading-header-image"
      );
    } else if (mainHeaderImage) {
      fadingHeaderImageExists = document.querySelector(
        "#main .header-right.fading-header-image"
      );
    }

    const svgClassName = fadingHeaderImageExists
      ? "svg-header-fading"
      : "svg-header-regular";

    addClassToBody("header-image-on");
    appendSvgToCanvas(
      svgClassName,
      beforeContentHeaderImage
        ? beforeContentHeaderImage.innerHTML
        : mainHeaderImage.innerHTML
    );
  } else if (mainHeaderImageWithoutType) {
    removeClassFromBody("header-slideshow-on");
    removeClassFromBody("maintenance-svg");
    appendSvgToCanvas(
      "svg-header-fading",
      mainHeaderImageWithoutType.innerHTML
    );

    if (mainMobileHeaderImage) {
      const canvas = document.querySelector(".dialog-off-canvas-main-canvas");

      if (canvas) {
        const existingSvg = canvas.querySelector(".bg-svgs.svg-header-fading");

        if (existingSvg) {
          existingSvg.classList.add("mobile-image-on");
          existingSvg.innerHTML +=
            '<div class="bg-mobile-image">' +
            mainMobileHeaderImage.innerHTML +
            "</div>";
        }
      }
    }
  } else if (mainHeaderSlideshow) {
    addClassToBody("header-slideshow-on");

    let existingSvg = document.querySelector(
      ".dialog-off-canvas-main-canvas .bg-svgs.svg-header-slideshow"
    );

    if (!existingSvg) {
      appendSvgToCanvas(
        "svg-header-slideshow",
        mainHeaderSlideshow.innerHTML
      );
    }
  } else if (pageNodePage) {
    let existingSvg = document.querySelector(
      ".dialog-off-canvas-main-canvas .bg-svgs.one-tour-base"
    );

    if (existingSvg) {
      existingSvg.classList.add("active");
    }
  } else if (pageNodeBikesPrices) {
    addClassToBody("header-slideshow-on");

    let existingSvg = document.querySelector(
      ".dialog-off-canvas-main-canvas .bg-svgs.svg-header-slideshow"
    );

    if (!existingSvg) {
      appendSvgToCanvas(
        "svg-header-slideshow",
        document.querySelector(".bike-top-right").innerHTML
      );
      document
        .querySelector(".bg-svgs.svg-header-slideshow .bike-images")
        .classList.add("field-slideshow");
    }
  } else {
    let existingSvg = document.querySelector(
      ".dialog-off-canvas-main-canvas .bg-svgs.maintenance-svg"
    );

    if (existingSvg) {
      existingSvg.classList.add("active");
    }
  }
});

function addClassToBody(className) {
  document.body.classList.add(className);
}

function removeClassFromBody(className) {
  document.body.classList.remove(className);
}

function appendSvgToCanvas(svgClassName, content) {
  const canvas = document.querySelector(".dialog-off-canvas-main-canvas");

  if (canvas) {
    const existingSvg = canvas.querySelector(".bg-svgs." + svgClassName);

    if (existingSvg) {
      existingSvg.remove();
    }

    const newSvg = document.createElement("div");
    newSvg.classList.add("bg-svgs", svgClassName);
    newSvg.innerHTML = '<div class="bg-image">' + content + "</div>";
    canvas.prepend(newSvg);
  }
}